import { useMemo } from "react";
import moment from "moment";
import { BigNumber } from "@ethersproject/bignumber";
import { getAssets, getVaultChain, isPutVault, VaultList, VaultVersionList, } from "../constants/constants";
import { getAssetDecimals } from "../utils/asset";
import useVaultActivity, { useAllVaultActivities } from "./useVaultActivity";
import { assetToFiat, formatOptionStrike } from "../utils/math";
import { useAssetsPrice } from "./useAssetPrice";
import { formatUnits } from "@ethersproject/units";
export var useLatestOption = function (vaultOption, vaultVersion) {
    var asset = getAssets(vaultOption);
    var _a = useVaultActivity(vaultOption, vaultVersion), activities = _a.activities, activityLoading = _a.loading;
    var _b = useAssetsPrice(), prices = _b.prices, assetPriceLoading = _b.loading;
    var chain = getVaultChain(vaultOption);
    var optionHistory = useMemo(function () {
        var sortedActivities = activities
            .filter(function (activity) { return activity.type === "minting"; })
            .sort(function (a, b) { return (a.date.valueOf() < b.date.valueOf() ? 1 : -1); });
        if (sortedActivities.length <= 0) {
            return [];
        }
        return sortedActivities.map(function (_shortPosition) {
            var shortPosition = _shortPosition;
            var optionTraded = activities.filter(function (activity) {
                return activity.type === "sales" &&
                    activity.vaultShortPosition.id === shortPosition.id;
            });
            var decimals = getAssetDecimals(asset);
            var isPut = isPutVault(vaultOption);
            return {
                strike: shortPosition.strikePrice,
                expiry: moment(shortPosition.expiry, "X"),
                premium: optionTraded.reduce(function (acc, curr) { return acc.add(curr.premium); }, BigNumber.from(0)),
                depositAmount: shortPosition.depositAmount,
                amount: isPut
                    ? parseFloat(assetToFiat(shortPosition.depositAmount, prices[asset], decimals)) / formatOptionStrike(shortPosition.strikePrice, chain)
                    : parseFloat(formatUnits(shortPosition.depositAmount, decimals)),
                isPut: isPut,
            };
        });
    }, [chain, activities, asset, prices, vaultOption]);
    // console.group('useLatestOption')
    // console.log('vaultOption')
    // console.log(vaultOption)
    // console.log('chain')
    // console.log(chain)
    // console.log('optionHistory')
    // console.log(optionHistory)
    // console.log('activities')
    // console.log(activities)
    // console.groupEnd()
    return {
        option: optionHistory.length > 0 ? optionHistory[0] : undefined,
        optionHistory: optionHistory,
        loading: activityLoading || assetPriceLoading,
    };
};
export var useLatestOptions = function () {
    var _a = useAllVaultActivities(), allActivities = _a.activities, activityLoading = _a.loading;
    var _b = useAssetsPrice(), prices = _b.prices, assetPriceLoading = _b.loading;
    var options = useMemo(function () {
        return Object.fromEntries(VaultVersionList.map(function (version) { return [
            version,
            Object.fromEntries(VaultList.map(function (vaultOption) {
                var asset = getAssets(vaultOption);
                var activities = allActivities[version][vaultOption];
                var sortedActivities = activities
                    .filter(function (activity) { return activity.type === "minting"; })
                    .sort(function (a, b) { return (a.date.valueOf() < b.date.valueOf() ? 1 : -1); });
                if (sortedActivities.length <= 0) {
                    return [vaultOption, []];
                }
                var chain = getVaultChain(vaultOption);
                return [
                    vaultOption,
                    sortedActivities.map(function (_shortPosition) {
                        var shortPosition = _shortPosition;
                        var optionTraded = activities.filter(function (activity) {
                            return activity.type === "sales" &&
                                activity.vaultShortPosition.id === shortPosition.id;
                        });
                        var decimals = getAssetDecimals(asset);
                        var isPut = isPutVault(vaultOption);
                        return {
                            strike: shortPosition.strikePrice,
                            expiry: moment(shortPosition.expiry, "X"),
                            premium: optionTraded.reduce(function (acc, curr) { return acc.add(curr.premium); }, BigNumber.from(0)),
                            depositAmount: shortPosition.depositAmount,
                            amount: isPut
                                ? parseFloat(assetToFiat(shortPosition.depositAmount, prices[asset], decimals)) / formatOptionStrike(shortPosition.strikePrice, chain)
                                : parseFloat(formatUnits(shortPosition.depositAmount, decimals)),
                            isPut: isPut,
                        };
                    }),
                ];
            })),
        ]; }));
    }, [allActivities, prices]);
    return {
        options: options,
        loading: activityLoading || assetPriceLoading,
    };
};
//# sourceMappingURL=useLatestOption.js.map